import { match } from 'ts-pattern';
import { zfd } from 'zod-form-data';
import {
  makeShippingProtectionClaimAction,
  makeShippingProtectionClaimLoader,
  redirect,
} from '~/utils/routing';
import { claimAddressSchema } from '~/utils/schemas';

export const { loader, useLoaderData } = makeShippingProtectionClaimLoader(
  ({ context: { shippingProtectionClaim, order } }) => ({
    address: shippingProtectionClaim.address ?? order.shippingAddress,
  }),
);

const schema = zfd.formData({
  address: claimAddressSchema,
});

export const { action, useActionResult } = makeShippingProtectionClaimAction(
  ({ formData }, appStore) =>
    match(schema.safeParse(formData))
      .with({ success: true }, ({ data: { address } }) => {
        appStore.dispatch(
          appStore.actions.shippingProtectionClaim.setAddress(address),
        );
        return redirect('../review');
      })
      .with({ success: false }, () => ({
        ok: false,
        message: 'Invalid address. Check your address information.',
      }))
      .exhaustive(),
);
